module.exports = __webpack_public_path__ + "pc/img/bg6.9a2c111.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprintClass/new/bg6.png
// module id = T68M
// module chunks = 3